/**
 * TasksModuleGuard — sperrt die Aufgaben-Routen, wenn die Firma das Modul oder den
 * Mitarbeiterzugang in den Aufgaben-Einstellungen abgeschaltet hat.
 *
 * Ergänzt, ersetzt nicht: Das Abo-Feature prüft weiterhin `FeatureGuard` bzw.
 * `TasksFeatureGuard`. Bewusst NICHT an `/settings/tasks` — sonst könnte niemand das
 * Modul wieder einschalten.
 *
 * Fail-open: Kommen die Einstellungen nicht, gelten die Defaults (= an). Gesperrt wird
 * ohnehin auf dem Server (403 `TASK_MODULE_DISABLED` / `TASK_EMPLOYEE_ACCESS_DISABLED`).
 */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserPermissionsService } from '../../employee/services/user-permissions.service';
import { TaskSettingsService } from '../settings/task-settings.service';
import { TasksSurface, isSurfaceEnabled } from './tasks-gate.service';

@Injectable({ providedIn: 'root' })
export class TasksModuleGuard implements CanActivate {
  private readonly taskSettings = inject(TaskSettingsService);
  private readonly permissions = inject(UserPermissionsService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const surface: TasksSurface = route.data?.['tasksSurface'] ?? 'employee';
    return this.taskSettings.ensureLoaded().pipe(
      map((settings) => {
        const allowed =
          settings.moduleEnabled &&
          isSurfaceEnabled(surface, settings, this.permissions.CurrentUserPermissions);
        return allowed || this.router.createUrlTree(['/']);
      }),
    );
  }
}
